

export default class aes {
  // 加密
  encrypt = (key, iv, text) => {
    if(text==null){
      return text;
    }
    var srcs = ''
    if (typeof (text) == 'string') {
      srcs = text
    } else{
      //对象格式的转成json字符串
      srcs = JSON.stringify(text);
    }
    return window.CryptoJS.AES.encrypt(srcs, window.CryptoJS.enc.Utf8.parse(key), {
      iv: window.CryptoJS.enc.Utf8.parse(iv),
      mode: window.CryptoJS.mode.CBC,
      padding: window.CryptoJS.pad.Pkcs7
    }).toString()
  }

  // 解密
  decrypt = (key, iv, text) => {
    if(text==null){
      return text;
    }
    let decrypted = window.CryptoJS.AES.decrypt(text, window.CryptoJS.enc.Utf8.parse(key), {
      iv: window.CryptoJS.enc.Utf8.parse(iv),
      mode: window.CryptoJS.mode.CBC,
      padding: window.CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(window.CryptoJS.enc.Utf8)
  }
};